// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-height[data-v-042804ac] {\n  line-height: 0;\n}\n.icon-overlap[data-v-042804ac] {\n  position: absolute;\n  top: -5px;\n  left: 1px;\n  width: -webkit-fill-available;\n  text-align: center;\n}\n.p-stat[data-v-042804ac] {\n  font-size: 34px;\n}\nfieldset[data-v-042804ac] {\n  padding: 0 4px;\n  height: 100%;\n  border-radius: 3px;\n  border-color: var(--v-grey-lighten2);\n}\n", ""]);
// Exports
module.exports = exports;
